module.exports = __webpack_public_path__ + "img/shoe1.cc41871e.png";